import { useEffect, useState } from "react";
import { useAppSelector } from "../..";
import { baseUrlName } from "../routes/baseUrl";

type TenantPropertiesDtoType = {
  propertyType: {
    alias: string;
  };
  numberValue: number;
};

export default function useBlockingMode() {
  const { tenantPropertiesDto } = useAppSelector((state) => state.tenants);

  const [isBlockingMode, setIsBlockingMode] = useState(false);
  useEffect(() => {
    const findBlockedModeProperties = (tenantPropertiesDto as TenantPropertiesDtoType[])?.find(
      ({ propertyType: { alias } }) => alias === "billing.blocking.mode"
    );

    const isBlockedModeProperties =
      !findBlockedModeProperties ||
      (findBlockedModeProperties && findBlockedModeProperties?.numberValue === 1);

    setIsBlockingMode(isBlockedModeProperties);
  }, [tenantPropertiesDto]);

  return isBlockingMode;
}
